
import React from 'react';
import './Navbar.css'; 

const Navbar = () => (
  <nav>
    <h1>CHATting is FUN !!</h1> 
  </nav>
);

export default Navbar;
